import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { withStyles } from 'material-ui/styles';
import SupportLogo from '../../../assets/images/SupportLogo.png';
import { getUserInfo } from 'spark-state/common/user/userReducer';
import { getMappedEnterpriseData } from 'spark-state/common/app/reducer';
import { configureSupportLinkURL } from 'spark-api/safetyLetter/commonSafetyLetterService';
import { appConfig } from '../../../config/appConfig';

const Page = styled.a`
& span:hover {
    text-decoration: underline;
}`

const NotFound = ({ classes }) => (
    <Page>
    <div>
        <div className={classes.root}> {'Our apologies, but you do not have access to this data.'} </div>
        <div className={classes.listHeader}> {'Possible reasons may include:'} </div>
        <li className={classes.list1}> {'There are currently no Safety Notifications associated with the email account you used to login.'}</li>
        <ul className={classes.listHeader}><li className={classes.list3}>{'Safety Notifications are only accessible using the email entered in CTMS. Please ensure this is the email you use to login.'}</li></ul> 
        <li className={classes.list2}> {'There are no Safety Notifications that have been distributed to you yet.'} </li>
        <ul className={classes.listHeader}><li className={classes.list3}>{'The distribution of Safety Notification is conducted by study team personnel. Please reach out to your study team representative to inquire about which roles receive Safety Notifications.'}</li></ul>
        <div className={classes.lastDiv}> {'If you think you\'ve encountered this page in error, please contact'} </div>
        <SupportLink />
        <b style={{fontWeight: 'bold', fontSize: '38px'}}> {'or your study team for assistance.'} </b>
    </div>
    </Page>
);

const styles = (theme) => ({
    rootDiv: {
        textAlight: 'center',
        position: 'absolute',
        width:'77em',
        left: '55%',
        top: '40%',
        transform: 'translate(-50%, -50%)',
        marginBottom: '25px'
    },
    root: {
        fontWeight: 'bold',
        fontSize: '36px',
        marginBottom: '25px'
    },
    lastDiv: {
        fontWeight: 'bold',
        fontSize: '38px'
    },
    list1: {
        fontSize: '28px'
    },
    list2: {
        fontSize: '28px',
        marginBottom: '25px'
    },
    list3: {
        fontSize: '28px',
        marginLeft: '40px',
        listStyleType: 'circle'
    },
    listHeader: {
        fontSize: '28px',
        marginBottom: '25px'
    }

})

const SupportLinkDisplay = ({ supportLink }) => (
    <a href={supportLink} target="_blank" rel="noopener noreferrer" style={{ color: 'black', textDecoration: 'none', display: 'inline-block',marginBottom:'0.2em'}}> {/* SAF-18222- Vulnerability Scan Issue fixes - reverse tab nabbing */}
        <img style={{verticalAlign:'middle',height:'45px',width:'45px'}} src={SupportLogo} alt=''></img>
        &nbsp;
        <span style={{fontWeight: 'bold', fontSize: '38px', color: 'grey'}}> {'Support'} </span>
    </a>
);

const ConnectedSupportLink = connect((state, { pathname }) => {
    const user = getUserInfo(state);
    const mappedEnterprise = getMappedEnterpriseData(state);
    const sponsor = mappedEnterprise && mappedEnterprise.filter(
        (i) => i.entId === parseInt(user.enterpriseId, 10));
    const supportURL = sponsor && sponsor.length ? (sponsor[0].supportURL ? sponsor[0].supportURL.split('?')[0] : '') : configureSupportLinkURL;
    return {
        supportLink: `${supportURL}?emailAddress=${user.email}&firstName=${
            user.given_name
        }&lastName=${user.family_name}&moduleName=${appConfig.MODULE_NAME}&redirectURL=${
            process.env.PUBLIC_URL
        }${pathname}${sponsor && sponsor.length ? `&sponsor=${encodeURIComponent(sponsor[0].entName)}` : ''}`
    };
})(SupportLinkDisplay);

export let SupportLink = () => {
    const location = useLocation();
    return <ConnectedSupportLink pathname={location.pathname} />;
};

export default withStyles(styles)(NotFound);
